<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-11-02 10:01:29
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimReason\ClaimReason.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_ClaimReason_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-claim-reason')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.claim_reason_name) }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.claim_reason_description) }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-claim-reason')"
            :editBtn="hasBtn('edit-admin-claim-reason')"
            :viewBtn="hasBtn('view-admin-claim-reason')"
            :title="$t('label_essweb_ClaimReason_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
export default {
  name: "ClaimReason",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      search: "",
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_ClaimReason_list_claimReasonLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_reason",
        url: "/claim-reason/get-claim-reason-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/claim-reason/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/claim-reason/edit/"
          : "/admin/claim-reason/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_reason",
        url: "/claim-reason/delete-claim-reason-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimReason_list_deleteClaimReasonSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
